import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import GreyTick from '../../assets/greyTick.svg';
import GreenTick from '../../assets/greenTick.svg';
import './style.scss';
import { sum, words } from 'lodash';
import { verifyGroupExpression, getDescription } from '../../utils/utility';
function RegexValidationUI({ value, userDetails, updateGroup }) {
	const [groups, setGroups] = useState([]);
	const verifyRegex = value => {
		groups.forEach(group => {
			if (!group.rule || group.rule.length === 0) {
				group.completed = true;
				return;
			}
			group.rule.forEach(rule => {
				if (value.match(rule.regex)) {
					rule.completed = 1;
				} else {
					rule.completed = 0;
				}
			});
			group.completed = verifyGroupExpression(group);
		});
		if (groups.length > 0) {
			setGroups([...groups]);
			updateGroup([...groups]);
		}
	};
	const parseRules = data => {
		const regexRules = data?.passwordValidationRules?.filter(rule => rule.ruleType === 'REGEX');
		let expression = data.expression;
		let exps = expression?.split('&&') || [];
		// Expression segments may reference tokens (e.g. email) with no REGEX rule — skip those
		// so we never read parseRule[0] when empty (reset-password / email flows).
		const groups = exps
			.map(exp => {
				const expTrim = exp.trim();
				let tokens = words(expTrim, /[A-z](?:_?[A-z0-9]+)/g);
				let parseRule = regexRules.filter(bb => expTrim.includes(bb.ruleId));
				let expParse = expTrim.replace(/[)()]/g, '');
				const title =
					tokens.length == 1
						? parseRule[0]?.description || ''
						: getDescription(expParse, tokens);
				return {
					completed: false,
					exp: expParse,
					rule: parseRule,
					title,
					expLength: tokens.length
				};
			})
			.filter(g => g.rule.length > 0);
		setGroups(groups);
	};
	useEffect(() => {
		parseRules(userDetails);
	}, []);
	useEffect(() => {
		verifyRegex(value);
	}, [value]);

	const GetTick = ({ isGreen }) => {
		return (
			<div className={`checkBox`}>
				{isGreen ? <img src={GreenTick} /> : <img src={GreyTick} />}
			</div>
		);
	};
	return (
		<div className="validationContainer">
			{value.length > 0 && <div className="passwordStrength"> Password Requirements:</div>}
			{value.length > 0 &&
				groups?.map((group, i) => (
					<div className="regexValidationWrapper" key={i}>
						{groups.length > 1 && (
							<div className="titleWrapper">
								<GetTick isGreen={group?.completed} />
								<div className={`title ${group?.completed ? 'isCompleted' : ''}`}>
									{group.title}
								</div>
							</div>
						)}
						<div
							className={`regexValidationContainer ${
								group.rule.length > 1 ? 'isMultipleGroup' : ''
							}`}
						>
							{group.rule?.map(
								rule =>
									group.expLength > 1 && (
										<div className="rule" key={rule.ruleId}>
											<GetTick isGreen={rule?.completed === 1} />
											<span
												className={`description ${
													rule?.completed === 1 ? 'isCompleted' : ''
												}`}
											>
												{rule?.description}
											</span>
										</div>
									)
							)}
						</div>
					</div>
				))}
		</div>
	);
}
RegexValidationUI.propTypes = {
	value: PropTypes.string,
	userDetails: PropTypes.any
};
export default RegexValidationUI;
